import {Switch} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {ExtraItem} from '../extra-item/ExtraItem'
import {classes} from './SmsCodeSwitch.classes'
import {SmsCodeSwitchProps} from './SmsCodeSwitch.types'

export function SmsCodeSwitch({name, isMobile = false}: SmsCodeSwitchProps): React.ReactElement {
  const {control} = useFormContext()
  const t = useI18n()

  return (
    <Controller
      control={control}
      name={name}
      render={({field, fieldState}) => {
        return (
          <div ref={field.ref}>
            <ExtraItem
              className={classes.root}
              title={t('cargo.create.contact.confirm_by_sms', 'Подтвердить передачу смс-кодом')}
              clean
            >
              <Switch
                error={fieldState.invalid}
                name={name}
                on={field.value}
                onChange={field.onChange}
                size={isMobile ? 's' : 'm'}
              />
            </ExtraItem>
          </div>
        )
      }}
    />
  )
}
